module.exports = __webpack_public_path__ + "img/assistant.29b8fc5c.png";